module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";